<template>
  <v-autocomplete
    v-model="internalValue"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    :outlined="outlined"
    :hide-details="hideDetails"
    :loading="loading"
    v-bind="$attrs"
    @click:clear="handleClear"
  />
</template>

<script>

export default {
  name: 'AutocompleteWithSessionUpdate',
  props: {
    value: { type: [String, Number, Object], default: null }, // Добавил Object, т.к. v-autocomplete может возвращать объект
    items: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    sessionStorageKey: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        // 1. Уведомляем родителя (v-model)
        this.$emit('input', val);
        
        // 2. Сохраняем в сессию
        if (this.sessionStorageKey && val !== null) {
          // Если val — объект, не забудьте JSON.stringify
          sessionStorage.setItem(this.sessionStorageKey, val);
        }
      }
    }
  },
  methods: {
    handleClear() {
      // 1. Уведомляем родителя, что значение очищено
      this.$emit('input', null);
      
      // 2. Удаляем из сессии
      if (this.sessionStorageKey) {
        sessionStorage.removeItem(this.sessionStorageKey);
      }
    }
  },
//   watch: {
//     // Когда items загрузятся, заставляем компонент пересчитать отображение
//     items: {
//       immediate: true,
//       handler(newItems) {
//         if (newItems && newItems.length > 0 && this.value) {
//           // Небольшой хак для Vuetify 2: 
//           // принудительно уведомляем систему реактивности
//           const current = this.value;
//           this.$emit('input', null);
//           this.$nextTick(() => {
//             this.$emit('input', current);
//           });
//         }
//       }
//     }
//   },

//   mounted() {
//     const savedValue = sessionStorage.getItem(this.sessionStorageKey);
//     // Если в сессии что-то есть и текущее значение пустое — восстанавливаем
//     if (savedValue !== null && !this.value) {
//       this.$emit('input', savedValue);
//     }
//   }
};
</script>